import { getDeliveryOptionRequestObjectFromService } from '@/utils/order'

const state = {}

// getters
const getters = {
  supportDeliveryOption: (state, rootGetters) => {
    const request = getDeliveryOptionRequestObjectFromService(rootGetters.orderFormService)
    return !!(request && request._id)
  },
  deliveryOptionRequest: (state, rootGetters) => {
    return getDeliveryOptionRequestObjectFromService(rootGetters.orderFormService)
  }
}

// actions
const actions = {}

// mutations
const mutations = {}

export default {
  state,
  getters,
  actions,
  mutations
}
